import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCollectAmountRangeModel } from 'src/app/model/cat-collect-amount-range.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatCollectAmountRangeService } from 'src/oldApp/services/cat-collect-amount-range.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';

@Component({
  selector: 'app-modal-collect-amount-range',
  templateUrl: './modal-collect-amount-range.component.html',
  styleUrls: ['./modal-collect-amount-range.component.css']
})
export class ModalCollectAmountRangeComponent implements OnInit {
  @Input() range:CatCollectAmountRangeModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus?:number=1;

  // catalogos
  public employeeJobCatalog:CatalogModel[];
  public collectAmountGroupCatalog:any[]=[
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'}
  ];

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ<>=,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private modalService: NgbModal,
    private collectAmountRangeService:CatCollectAmountRangeService,
    private employeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updateCommission=e=> this.range.commission=!e || e.trim()===''?null:Number(e);
  updateMinCollect=e=> this.range.minCollect=!e || e.trim()===''?null:Number(e);
  updateMaxCollect=e=> this.range.maxCollect=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.range.activeId=!this.range.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.collectAmountGroupError()) errors.push('Nececita seleccionar un grupo.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(this.minCollectError()) errors.push('Necesita capturar un cobro mínimo.');
    if(this.maxCollectError()) errors.push('Necesita capturar un cobro máximo.');
    if(this.minCollectMayorError()) errors.push('El cobro mínimo no puede ser mayor al cobro máximo.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.range.description=this.range.description.toUpperCase();
      this.collectAmountRangeService.save(this.range)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('El rango se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar el rango.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.range.description || this.range.description.trim()==='';
  employeeJobError=()=> !this.range.employeeJobId;
  collectAmountGroupError=()=> !this.range.collectAmountGroupId;
  commissionError=()=> this.range.commission!==0 && !this.range.commission;
  minCollectError=()=> this.range.minCollect!==0 && !this.range.minCollect;
  maxCollectError=()=> this.range.maxCollect!==0 && !this.range.maxCollect;
  minCollectMayorError=()=> this.range.minCollect > this.range.maxCollect;

  // INFO
  getCatalogs=()=> {
    this.employeeJobService.catalog()
      .pipe(
        tap((resp:any)=> {
          if(resp) {
            this.employeeJobCatalog=resp.data.filter(cat => cat.id===4);
            this.viewStatus=1;
          }
          else throwError;
        }),
        catchError(error=> {
          console.log(error);
          this.modalService.dismissAll('failure');
          return of(this.toastr.error('Ocurrió un error al buscar catálogos.'));
        })
      )
      .subscribe();
  }
}
